<template>
  <ErrorBoundary module-name="TheFooter">
    <footer class="footer">
      <div class="footer__wrapp">
        <div class="footer__categories">
          <div
            v-for="(item, index) in footerItems"
            :key="index"
            class="footer__category"
          >
            <span class="footer__category-title">{{ item.name }}</span>
            <BHLink
              v-for="link in item.items"
              :key="link.id"
              class="footer__category-nav-link"
              target="_blank"
              :href="link.link"
              colorless
              @click="sendAnalytics(link)"
            >
              {{ link.title }}
            </BHLink>
          </div>
        </div>
        <div class="footer__warnings">
          <div class="footer__age">18+</div>
          <div class="footer__texts">
            <p
              v-for="(warning, index) of warnings"
              :key="index"
              class="footer__text"
            >
              {{ warning.text }}
            </p>
          </div>
        </div>
      </div>
    </footer>
  </ErrorBoundary>
</template>

<script lang="ts">
  import footerData from '~/constants/components/footer';
  import BHLink from '~/components/BHLink.vue';
  import { removeBurninghutFromUrl } from '~/utils/link';
  import { useMenusStore } from '~/store/menus';
  import ErrorBoundary from '@devhacker/shared/components/ErrorBoundary.vue';

  export default defineNuxtComponent({
    name: 'TheFooter',
    components: {
      BHLink,
      ErrorBoundary,
    },

    computed: {
      footerItems() {
        return useMenusStore().footerItems;
      },

      warnings() {
        return footerData.warnings;
      },
    },

    methods: {
      removeBurninghutFromUrl,

      // Функция для аналитики клика на элемент футера
      sendAnalytics(_item: unknown) {
        // const currentSlug = getSlugFromUrl(this.$route.fullPath);
      },
    },
  });
</script>

<style lang="scss" scoped>
  .footer {
    background-color: black;
    font-family: $text-font--1;

    @include font(
      (
        'fs': 16px,
        'lh': 24px,
        'fw': 500,
      )
    );

    &__wrapp {
      width: 100%;
      padding: $spacing-8 $spacing-7 $spacing-12 $spacing-4;
      @include tablet {
        padding: $spacing-8 $spacing-8 $spacing-8 $spacing-6;
        max-width: 876px;
      }
      @include big-tablet {
        padding: $spacing-8 $spacing-15 $spacing-8 $spacing-3;
      }
      @include desktop-wide {
        max-width: 1280px;
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
      }
      margin: 0 auto;
    }

    &__categories {
      margin-bottom: $spacing-3;
      @include tablet {
        margin-bottom: $spacing-5;
      }
    }

    &__category {
      display: flex;
      flex-wrap: wrap;
      &:not(:last-child) {
        margin-bottom: $spacing-8;

        @include tablet {
          margin-bottom: $spacing-4;
        }
        @include big-tablet {
          margin-bottom: $spacing-0;
        }
      }
    }

    &__category-title {
      color: $disabled-color--2;
      display: block;
      margin-bottom: $spacing-4;
      margin-right: $spacing-6;
      width: 100%;

      @include tablet {
        width: auto;
      }
    }

    &__category-nav-link {
      word-break: break-word;
      color: $onDarkColor;

      &:not(:last-child) {
        margin-bottom: $spacing-4;
        margin-right: $spacing-6;
      }

      @include hover {
        color: #ffffff;
      }
    }
    &__warnings {
      color: $disabled-color--2;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      max-width: 288px;

      @include desktop-wide {
        display: block;
      }
    }

    &__age {
      border: 1px solid #969698;
      color: #969698;
      border-radius: 4px;
      font-family: 'PTRootUIWeb', sans-serif;
      @include font(
        (
          'fw': 600,
          'fs': 16px,
          'lh': 24px,
        )
      );
      padding: 6px 4.5px;
      margin-right: $spacing-2;

      @include desktop-wide {
        max-width: 36px;
        margin-bottom: $spacing-2;
      }
    }

    &__text {
      color: $text-color--3;
      font-family: $text-font--1;
      @include font(
        (
          'fs': 10px,
          'lh': 13px,
          'fw': 300,
        )
      );
    }
  }
</style>
